module.exports = __webpack_public_path__ + "img/dver_orgalit.6ae55601.svg";